import { render } from "./BankAccountFormContainer.vue?vue&type=template&id=fc609208"
import script from "./BankAccountFormContainer.vue?vue&type=script&lang=js"
export * from "./BankAccountFormContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__